import service from '@/api/request';

/** 获取角色列表 */
export type CompListResponse = {
  current: number;
  size: number;
  pages: number;
  records: Array<{
    /** 赛事id */
    compId: string;
    /** 赛事名称 */
    compName: string;
    /** 赛事类型 */
    compType: string;
    /** 赛事类型名 */
    compTypeName: string;
  }>;
  total: number;
};
export type CompListParams = {
  compCode?: string;
  compName?: string;
  compType?: string;
  current: number;
  size: number;
  status?: string;
};
/**10中金所，2金融挑战赛，1菁英挑战赛 */
export const getCompList = (params: CompListParams) =>
  service.post<CompListParams, CompListResponse>('/api/comp/queryForPage', params, { mock: false });

export type CompDetailType = {
  compCode: string;
  compId: number;
  compName: string;
  compType: number;
  compTypeName: string;
  contestType?: string;
  contestTypeName?: string;
  creator: string;
  eitime: string;
  eutime: string;
  modifier: string;
  preCompId: 0;
  preCompName: string;
  status: number;
  statusName: string;
};
export const getCompDetail = ({ compId }: { compId: string }) =>
  service.post<null, CompDetailType>('/api/comp/getCompDetail', { compId: compId }, { mock: false });

type CreateCompParams = {
  compId?: number;
  compCode: string;
  compName: string;
  compType?: number;
  preCompId?: number;
  status?: number;
};
export const createComp = (params: CreateCompParams) =>
  service.post<CreateCompParams>('/api/comp/createComp', params, { mock: false });

type UpdateCompParams = {
  compId?: number;
  compCode: string;
  compName: string;
  compType?: number;
  preCompId?: number;
  status?: number;
};
export const updateComp = (params: UpdateCompParams) =>
  service.post<UpdateCompParams>('/api/comp/updateComp', params, { mock: false });

/** 获取比赛权限列表 */
export type CompAuthListParams = {
  authId?: string;
  /** 1-用户 2-角色 */
  authType: number;
  compId?: number;
  current: number;
  size: number;
};
export type CompAuthListResponse = {
  current: number;
  size: number;
  pages: number;
  records: Array<{
    authId: string;
    authName: string;
    authType: number;
    compId: number;
    creator: string;
    eitime: string;
    id: string;
  }>;
  total: number;
};
export const getCompAuthList = (params: CompAuthListParams) =>
  service.post<CompAuthListParams, CompAuthListResponse>('/api/comp/queryCompAuthorityByPage', params, { mock: false });

/** 添加赛事权限 */
export type AddCompAuthParams = {
  authId?: string;
  /** 1-用户 2-角色 */
  authType: number;
  compId?: number;
};
export const addCompAuthority = (params: AddCompAuthParams) =>
  service.post<AddCompAuthParams>('/api/comp/addCompAuthority', params, { mock: false });

/** 删除赛事权限 */
export type DeleteCompAuthParams = {
  id: string;
};
export const deleteCompAuthority = (params: DeleteCompAuthParams) =>
  service.post<AddCompAuthParams>('/api/comp/deleteCompAuthority', params, { mock: false });

// 分页查询赛事信息
export const queryForPage = data => service.post<null, Global.RecordResponse>('/api/comp/queryForPage', data);
